module.exports = __webpack_public_path__ + "img/equipment.1c0ec218.webp";